module.exports = __webpack_public_path__ + "img/envelope-large.5dbc53f2.png";